import { sendAnalytics } from '../NavBar/NavBar';

export function logIn(event: React.MouseEvent<HTMLDivElement>): void {
    event.preventDefault();

    sendAnalytics(event, 'Mobile / Log in');

    window.location.href = `${window.location.origin}/app/login`;
}
